export default __webpack_public_path__ + "static/media/cubeOutline.981ecacf.svg";